import React from "react"
import { AGGREGATION_PRICE } from "Pages/BusinessLogistics/BI/Page/@constants"
import { AppToggleButton } from "@components"
import { tableOption } from "Pages/BusinessLogistics/LeadingAnalyzer/Page/@signals"
import { TABLE_OPTION } from "Pages/BusinessLogistics/LeadingAnalyzer/Page/@constants"

const TABS = [
	{ label: 'Min. Price', value: TABLE_OPTION.MIN },
	{ label: 'Avg. Price', value: TABLE_OPTION.AVG },
	{ label: 'Max. Price', value: TABLE_OPTION.MAX },
]


export default function LeadingTableToolbar({ ...props }) {

	const handleButtonClick = (_, newValue) => {
		tableOption.value = newValue != null ? newValue : AGGREGATION_PRICE.AVG
	}

	return <AppToggleButton
		tabs={TABS}
		value={tableOption.value}
		onChange={handleButtonClick}
		buttonProps={{
			sx: { px: 2.5, py: 1 }
		}}
		{...props}
	/>
}